import { z } from 'zod';

/** Metadados de paginacao devolvidos pela API em toda listagem. */
export const paginationMetaSchema = z.object({
  page: z.number().int().positive(),
  pageSize: z.number().int().positive(),
  total: z.number().int().nonnegative(),
  totalPages: z.number().int().nonnegative(),
});

export type PaginationMeta = z.infer<typeof paginationMetaSchema>;

/** Erro de campo devolvido em `422`, no formato que os formularios consomem. */
export const fieldIssueSchema = z.object({ field: z.string(), message: z.string() });
export type FieldIssue = z.infer<typeof fieldIssueSchema>;

/**
 * Envelope de sucesso.
 *
 * @param data Schema do conteudo de `data`.
 */
export function apiSuccessSchema<T extends z.ZodType>(data: T) {
  return z.object({ success: z.literal(true), data, meta: paginationMetaSchema.optional() });
}

export const apiErrorSchema = z.object({
  success: z.literal(false),
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
    correlationId: z.string().optional(),
  }),
});

export type ApiErrorBody = z.infer<typeof apiErrorSchema>;

/** Resultado de uma listagem, com os itens ja validados. */
export interface PagedResult<T> {
  items: T[];
  meta: PaginationMeta;
}
